import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Age extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
    }

    render() {
        const { t, value } = this.props

        const ageYearTranslation = t('visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.identity.ageYear', { count: parseInt(value)})
        const ageValue = `${value} ${ageYearTranslation}`

        return (
            <span title={ ageValue }>
                { ageValue }
            </span>
        )
    }
}

export default withTranslation()(Age)
